import EditFolder from './EditFolder';

export default EditFolder;
